import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const allowanceListService = (params: Types.AllowanceListRequest) =>
  RestAPIClient.call<Types.AllowanceListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const allowanceListShortService = (params: Types.AllowanceListRequest) =>
  RestAPIClient.call<Types.AllowanceListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShort,
    config: {
      requireAuthentication: true,
      params,
      byPassError: true,
    },
  });

export const allowanceCreateService = (params: Types.AllowanceCreateRequest) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const allowanceUpdateService = (params: Types.AllowanceUpdateRequest) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const allowanceDeleteService = (id: string) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const allowanceDetailService = (id: string) =>
  RestAPIClient.call<Types.Allowance>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });
